module.exports = __webpack_public_path__ + "static/media/Paytm_UPI.b17b9d51.png";